<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-11 router-view-background">
    <div class="info-grid col-md-12">
      <div class="info-item"><span>Serviço</span><b>{{service_single.code}}</b></div>
      <div class="info-item">
        <span>Status</span>
        <div class="status" :style="'background-color:' + returnColorForStatus(service_single.status)">
          <span>{{service_single.status ? service_single.status : ""}}</span>
        </div>
      </div>
      <div class="info-item info-item--wide"><span>Criador</span><b>{{service_single.person ? service_single.person.name : " - "}}</b></div>
      <div class="info-item info-item--wide"><span>Propriedade</span><b>{{service_single.farm ? service_single.farm.name : " - "}}</b></div>
      <div class="info-item"><span>Data do Serviço</span><b>{{!service_single.date ? "-" : parseDate(service_single.date)}}</b></div>
      <div class="info-item"><span>Data da Emissão</span><b>{{!service_single.date_emission ? " - " : $_formatDateTime(service_single.date_emission)}}</b></div>
      <div class="info-item"><span>Data do Encerramento</span><b>{{!service_single.date_close ? " - " : service_single.date_close}}</b></div>
      <div class="info-item"><span>Controlador</span><b>{{service_single.partner ? service_single.partner.name : " - "}}</b></div>
    </div>

    <div class="milking-row col-md-12 d-flex justify-content-evenly">
      <div class="col-md-2">
        <h5>Esgotamento</h5>
        <h6>Data: {{service_single.exhaustion_date}}</h6>
        <h6>Hora Inicial: {{service_single.exhaustion_start_hour}}</h6>
        <h6>Hora Final: {{service_single.exhaustion_end_hour}}</h6>
      </div>

      <div class="col-md-2">
        <h5>1º Ordenha</h5>
        <h6>Data: {{service_single.first_weight_date}}</h6>
        <h6>Hora Inicial: {{service_single.first_weight_start_hour}}</h6>
        <h6>Hora Final: {{service_single.first_weight_end_hour}}</h6>
      </div>

      <div class="col-md-2">
        <h5>2º Ordenha</h5>
        <h6>Data: {{service_single.second_weight_date}}</h6>
        <h6>Hora Inicial: {{service_single.second_weight_start_hour}}</h6>
        <h6>Hora Final: {{service_single.second_weight_end_hour}}</h6>
      </div>

      <div class="col-md-2">
        <h5>3º Ordenha</h5>
        <h6>Data: {{service_single.third_date}}</h6>
        <h6>Hora Inicial: {{service_single.third_start_hour}}</h6>
        <h6>Hora Final: {{service_single.third_end_hour}}</h6>
      </div>
    </div>

    <div class="col-md-12 px-0 mt-4">
      <div class="form-panel">
        <!-- filtro de animais por nome e brinco -->
        <v-text-field
          class="form-panel__field form-panel__field--wide"
          outlined
          dense
          label="Pesquisa"
          prepend-inner-icon="mdi-magnify"
          @input="searchAnimal"
        ></v-text-field>

        <div v-if="this.allAnimals.length > 0" class="form-panel__actions">
          <v-select
            outlined
            dense
            label="Exibindo"
            :items="valuesForAmount"
            item-text="title"
            item-value="value"
            :value="valuePerPage"
            @change="$_setAmount"
            style="max-width:110px"
          ></v-select>
          <span class="text-nowrap">
            <strong style="color:var(--green)">{{in_page > total_items ? total_items : in_page}}</strong>
            /
            <strong style="color:var(--green)">{{total_items}}</strong> 
            Registros
          </span>
        </div>
      </div>
    </div>
    
    <div class="col-md-12">
      <the-table 
        :key="tableKey"
        id="service-details"
        :dataItems="computedAnimals"
        :headers="headersForTable"
      >
        <template v-slot:situationHeader="">
          <span class="d-flex justify-content-center">Situação</span>
        </template>
        <template v-slot:situation="{item}">
          <div 
            class="round-icon mx-auto"
            :style="`background-color:${item.status && item.status.color ? item.status.color : 'transparent'} !important`"
            v-tooltip.top="{content:formatStatus(item.status)}"
          ></div>
          <p class="d-block text-center">{{item.observation ? item.observation : ""}}</p>
        </template>
        <template v-slot:childrenHeader="">
          <span class="d-flex justify-content-center">Bezerro no pé?</span>
        </template>
        <template v-slot:on_foot="{item}">
          <span class="d-flex justify-content-center">
            <v-switch
              inset
              color="var(--green)"
              v-model="item.on_foot"
              class="table-item"
              :disabled="true"
              style="width:45px"
            ></v-switch>
          </span>
        </template>
        <template v-slot:milk_analysis="{item}">
          <span class="d-flex justify-content-center">
            <a class="text-link" @click="openModalAnalysis(item)">Análise</a>
          </span>
        </template>
        <template v-slot:closure="{item}">
          <span class="text-center" v-if="item.kind_explanation || item.date_explanation">
             <small v-if="item.date_explanation" class="d-block">Data: {{parseDate(item.date_explanation)}}</small>
              <small class="d-block">Motivo: {{item.kind_explanation ? item.kind_explanation.name : ""}}</small>
          </span>
        </template>
        <template v-slot:lactation="{item}">
          <div class="d-flex flex-column align-items-center">
            <span v-for="lact in item.lactation" :key="lact.id">{{lact.title}}</span>
          </div>
        </template>
      </the-table>
    </div>

    <div class="col-md-12 d-flex justify-content-end" style="margin-top:5vh">
      <v-pagination
        v-model="page"
        :length="total_pages"
        :total-visible="8"
        color="var(--jersey-yellow)"
      ></v-pagination>
    </div>

    <div class="col-md-12 d-flex justify-content-end mt-10">
      <div class="col-md-6">
        <v-text-field
          outlined
          label="Observação"
          v-model="service_single.observation"
          :disabled="true"
        ></v-text-field>
      </div>
    </div>

    <div class="col-md-12 mt-5">
      <the-actions
        color="#dfa006"
        sub-color="#ffffff"
        action-text="Editar Serviço"
        path-back="Services-list"
        :show-save="checkStatus"
        :extraAction="checkStatus"
        extraActionId="weightIn"
        @save="$router.push({name:'Edit-service', params:{id:service_single.id}})"
      >
        <template v-slot:weightIn="">
          <v-btn 
            v-if="checkStatus"
            class="mr-5 success"
            @click="$router.push({name:'Weight-in-create', params:{id:service_single.id}})"
          >
            Informar Pesagens
          </v-btn>
        </template>
      </the-actions>
    </div>

    <button-export 
      :excel="false"
      @export-pdf="PDFExport"
    />

    <modal-analysis 
      :active="openMilkModal"
      :milkAnalysis="milkAnalysis"
      @close="openMilkModal = false"
    />
  </div>
</template>

<script>
  import {mapActions, mapState} from "vuex";
  import TheTable from "@/components/layout/TheTable";
  import TheActions from "@/components/layout/TheActions";
  import ButtonExport from "@/components/layout/ButtonExport";
  import helpers from "@/mixins/helpers.js";
  import { jsPDF } from "jspdf";
  import 'jspdf-autotable';

  export default {
    name:"ServiceDetails",
    mixins:[helpers],
    components: {
      TheTable,
      TheActions,
      ButtonExport,
      ModalAnalysis: () => import("./ModalAnalysis.vue")
    },
    data() {
      return {
        headersForTable:[
        {text:"Situação", value:"situation", has_slot:true, header_slot:"situationHeader"},
        {text:"Animal", value:"name"},
        {text:"Brinco", value:"code"},
        {text:"Lote", value:"lot"},
        {text:"Regime Alimentar", value:"regime"},
        {text:"Bezerro no pé?", value:"on_foot", has_slot:true, header_slot:"childrenHeader"},
        {text:"Esgota", value:"exhaustion"},
        {text:"1º", value:"first_weight"},
        {text:"2º", value:"second_weight"},
        {text:"3º", value:"third_weight"},
        {text:"Último Parto", value:"last_birthday"},
        {text:"Lactação", value:"lactation", has_slot:true},
        ],
        allAnimals:[],
        valuePerPage:50,
        tableKey:0,
        valuesForAmount:[
          {title:"10", value:10},
          {title:"25", value:25},
          {title:"50", value:50},
          {title:"100", value:100},
        ],
        amount:50,
        openMilkModal:false,
        milkAnalysis:{}
      }
    },
    computed: {
      ...mapState("service", ["service_single"]),
      ...mapState("animals", ["regimes","explanations","closure_reasons"]),
      ...mapState("login", ["user"]),
      checkStatus() {
        return this.service_single.status !== 'Finalizado' && this.service_single.status !== 'Validado' && this.service_single.status !== 'Classificado' ? true : false
      },
      listSortCount() {
        if(this.allAnimals.length < this.amount) {
          return this.allAnimals.length;
        }
        if(this.computedAnimals.length > this.amount + 1) {
          return this.amount + this.computedAnimals.length; 
        }
        else {
          return this.amount;
        }
      },
      computedAnimals() {
        if(this.allAnimals.length) {
          return [
            ...this.allAnimals
            .map(e => {
              const animal = e.animal || {};
              return {
                ...e,
                ...animal,
                group:animal.group ? animal.group.name : " - ",
                approved:e.approved, search_key:e.search_key,
                regime:this.regimes.find(regime => regime.id === e.regime)?.description,
                kind_explanation:e.kind_explanation
              }
            })
          ]
        } else {
          return [];
        }
      }
    },
    methods: {
      ...mapActions("service", ["actionGetSingleService"]),
      ...mapActions("animals", [
        "actionGetRegimes",
        "actionGetAnimalsReasons"
      ]),
      parseDate(date) {
        const [year, month, day] = date.split("-");
        return day+"-"+month+"-"+year;
      },
      setAmount(data) {
        this.amount = data;
        this.valuePerPage = data;
        this.tableKey = this.tableKey + 1;
      },
      //Esse metodo retorna a cor do status 
      returnColorForStatus(status) {
        let result = "";
        if(status) {
          switch(status) {
            case "Pendente":
              result = "#1f6fd1"
              break;
            case "Fechado":
              result = "#127a5c";
              break;
            case "Em preenchimento":
              result = "#56707a";
              break;
            case "Validado":
              result = "#2e7d32";
              break;
            case "Classificado":
              result = "#9044eb";
              break;
              default:
                result = "#b45f06";
          }
          return result;
        } else {
          return "#FFFFFF"
        }
      },
      formatStatus(status) {
        return !status || (!status.description && !status.title) ? "-" : `${status.description || "-"} - ${status.title || "-"}`;
      },
      returnSituationTitle(animal) {
        let result = "";
        switch(animal.approved) {
          case true:
            result = "Aprovado";
            break;
          case false:
            result = "Reprovado";
            break;
          default:
            result = "";
        }
        return result;
      },
      returnSituationColor(animal) {
        let result = "";
        switch(animal.approved) {
          case true:
            result = "#2e7d32";
            break;
          case false:
            result = "#e09523";
            break;
          default:
            result = "";
        }
        return result;
      },
      async PDFExport() {
        const service = this.service_single;
        const doc = new jsPDF({ orientation: 'l', unit: 'pt' });
        doc.text('Detalhamento do serviço '+ service.code , 350, 40);
        doc.setFontSize(10)
        doc.text(`serviço: ${service.code}`, 40, 80);
        doc.text(`Data do Serviço: ${this.parseDate(service.date)}`, 40, 110)
        doc.text(`Data da Emissão: ${service.date_emission}`, 40, 140);
        doc.text(`Data da Encerramento: ${!service.date_close ? ' - ' : service.date_close }`, 40, 170);
        doc.text(`Propriedade: ${service.farm.name}`, 40, 200);
        doc.text(`Controlador: ${service.partner.name}`, 40, 230);
        doc.text(`Criador: ${service.person.name}`, 40, 260);
        const didParseCell = (table) => {
          if (table.section === 'head') {
            table.cell.styles.fillColor = '#150b32';
            table.cell.styles.textColor = '#FFFFFF';
            table.cell.styles.valign = 'middle'
          }
        }
        doc.autoTable({
          html: `#service-details`,
          margin: { top: 270 },
          didParseCell,
          columnStyles: {
            0: { cellWidth: 100 },
          }
        });
        doc.save(`detalhamento_de_servico_${Date.parse(new Date())}.pdf`);
      },
      //Esse metodo faz a pesquisa do animais
      searchAnimal(data) {
        const serviceDetailsAnimalsList = JSON.parse(localStorage.getItem("service-details-animals-list"));
        if(data.length) {
          const finded = serviceDetailsAnimalsList.filter(e => e.search_key.toLowerCase().includes(data) || e.search_key.includes(data));
          this.allAnimals = finded;
        } else {
          this.allAnimals = serviceDetailsAnimalsList;
        }
      },
      openModalAnalysis(animal) {
        this.openMilkModal = true;
        this.milkAnalysis = {
          name:animal.animal.name,
          fat:animal.fat,
          protein:animal.protein,
          lactose:animal.lactose,
          ccs:animal.css
        }
      },
      returnLactations(animal) {
        if(!animal || animal.lactation == null || String(animal.lactation).trim() === "") {
          return [];
        }

        return String(animal.lactation).split(",")
          .map(id => id.trim())
          .filter(Boolean)
          .map(id => this.explanations.find(explanation => String(explanation.id) === id)
            || {id, title:`Não identificado (${id})`});
      }
    },
    async mounted() {
      const id = this.$route.params.id;
      if(id) {
        await this.actionGetSingleService(id);
        await this.actionGetRegimes();
        await this.actionGetAnimalsReasons();
        if(this.service_single.service_animals.filter(e => e.kind_explanation || e.date_explanation).length) {
          this.headersForTable.push({text:"Encerramento da Lactação", value:"closure", has_slot:true})
        }
        this.allAnimals = [...this.service_single.service_animals.map(e => {
        const animal = e.animal || {};
        return {
        ...e,
        animal,
        lactation:this.returnLactations(e),
        kind_explanation:!e.kind_explanation ? undefined : this.closure_reasons.find(a => a.id == e.kind_explanation),
        animal_id:animal.id,
        search_key:[animal.register, animal.code, animal.name].filter(Boolean).join(" ").normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        }}),
        ];
        localStorage.setItem("service-details-animals-list", JSON.stringify(this.allAnimals));
        this.total_pages = Math.ceil(this.allAnimals.length / this.valuePerPage);
        this.total_items = this.allAnimals.length;
        this.allAnimals = this.allAnimals.filter((a,i) => i < this.valuePerPage);
        this.in_page = this.valuePerPage;
      }
      if(this.user.attributes.kind === "controler") {
        this.headersForTable.unshift({text:"Situação", value:"approved", has_slot:true, header_slot:"situationHeader"})
      }
      if(this.service_single.status === "Classificado") {
        this.headersForTable.push({text:"Análise de Leite", value:"milk_analysis", has_slot:true})
      }
    }
  }
</script>

<style scoped>
  .status {
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size:0.9rem;
    padding:5px 20px;
    border-radius: 10px;
    width: fit-content;
  }
  .round-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
</style>
